import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/oDbtMe9jinnmg6XCEswtBP/1.png', 'https://cdn.magicpatterns.com/uploads/tGc5Z1qRZHbRkpgYRZDUXM/2.png', 'https://cdn.magicpatterns.com/uploads/etvZEFbm3KvyD7KTAHsp5L/3.png', 'https://cdn.magicpatterns.com/uploads/nk3i48no1qktFenGVw68v1/4.png', 'https://cdn.magicpatterns.com/uploads/vs8sX1D4w2DMMzA28FQ9V7/5.png', 'https://cdn.magicpatterns.com/uploads/fiY4swb4E8boiEJicRRkN4/7.png'];
// Duplicate for seamless loop
const allImages = [...images, ...images];
export function ReviewsCarousel() {
  return <section className="py-12 md:py-16 bg-chocolate overflow-hidden relative" data-id="element-367">
      <style data-id="element-368">{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 28s linear infinite;
        }
      `}</style>

      <div className="max-w-5xl mx-auto px-4 mb-8 md:mb-12" data-id="element-369">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-white text-center uppercase leading-tight max-w-3xl mx-auto" data-id="element-370">
          ¡Deja de perder horas buscando patrones complicados que no salen como
          prometen!
        </motion.h2>
      </div>

      <div className="relative w-full overflow-hidden py-4" data-id="element-371">
        {/* Gradient fades */}
        <div className="absolute top-0 left-0 w-12 md:w-32 h-full bg-gradient-to-r from-chocolate to-transparent z-10 pointer-events-none" data-id="element-372" />
        <div className="absolute top-0 right-0 w-12 md:w-32 h-full bg-gradient-to-l from-chocolate to-transparent z-10 pointer-events-none" data-id="element-373" />

        {/* Marquee track */}
        <div className="flex items-center animate-marquee w-max gap-5 md:gap-6" data-id="element-374">
          {allImages.map((src, i) => {
          const isLarge = i % 2 === 0;
          return <div key={`review-${i}`} className={`flex-shrink-0 ${isLarge ? 'w-[300px] md:w-[360px]' : 'w-[220px] md:w-[260px]'}`} data-id="element-375">
                <img src={src} alt="Reseña de cliente" className="w-full h-auto rounded-xl shadow-2xl object-cover border border-white/10" loading="lazy" data-id="element-376" />
              </div>;
        })}
        </div>
      </div>
    </section>;
}